import appStrings from '@/assets/constants/appStrings-no.ts';
import Page from '@/components/Page/index.ts';
import { competitionWinnersQuery } from '@/lib/api/requests.ts';
import { getQueryClient } from '@/lib/query-client-context.ts';

import type { Route } from './+types/LandingPage';
import CalendarContainers from './_pages/CalendarContainers/index.ts';

export async function loader({ context }: Route.LoaderArgs) {
  const queryClient = getQueryClient(context);
  const competitions = await queryClient.query(competitionWinnersQuery());
  const competition = competitions.find((c) => c.slug === 'advent_of_loans_2023');

  return {
    winners: competition?.winners ?? [],
    meta: competition?.meta,
  };
}

export default function LandingPage({ loaderData }: Route.ComponentProps) {
  return (
    <Page title={appStrings.MENU.DECEMBER_2023_COMPETITION}>
      <CalendarContainers winners={loaderData.winners} meta={loaderData.meta} />
    </Page>
  );
}
